import styled from 'styled-components'

export const Container = styled.header`
    width: 95%;
    margin: 1rem auto;

    display: flex;
    align-items: center;
    justify-content: space-between;

    h2{
        color: #393939;
        font-size: 2rem;
    }

    span{
        font-size: 1.4rem;
        color: #7A05A7;
        z-index: 999;

        @media (min-width: 960px){
            cursor: pointer;
        }
    }
`